<p-table [value]="items()" [loading]="loading()">
  <ng-template pTemplate="header">
    <tr>
      <th>User / Anonymous ID</th>
      <th>Key</th>
      <th>Response</th>
      <th>Description</th>
      <th>Created At</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item [cTypedTableRow]="items()">
    <tr>
      <td>{{ item.userOrAnonymousId }}</td>
      <td>{{ item.key }}</td>
      <td>{{ item.response }}</td>
      <td>{{ item.description }}</td>
      <td>{{ item.createdAt | date:'M/d/yy, h:mm a' }}</td>
    </tr>
  </ng-template>
</p-table>
